module.exports = __webpack_public_path__ + "img/heart.94a01fae.svg";